export default "/images/arrow-down-circle.svg?d77ecc180895dd94597ba97f96de32c9";